import { render, staticRenderFns } from "./SessionSetupModal.vue?vue&type=template&id=0f997feb&scoped=true"
import script from "./SessionSetupModal.vue?vue&type=script&lang=js"
export * from "./SessionSetupModal.vue?vue&type=script&lang=js"
import style0 from "./SessionSetupModal.vue?vue&type=style&index=0&id=0f997feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f997feb",
  null
  
)

export default component.exports